import MidwayIdentityJavaScriptClient  from "@amzn/midway-identity-javascript-client";
import { getSelfServiceEndpointConfig } from "./spotcp-self-service-endpoint-configs";

export default class MidwayClient {
    selfServiceClient;

    constructor() {
        const endpointConfig = getSelfServiceEndpointConfig();
        this.selfServiceClient = new MidwayIdentityJavaScriptClient(endpointConfig);
    }
}


// WEBPACK FOOTER //
// ./src/components/spotlight/spotcp-midway_client.jsx